import * as types from './mutation-types'
import { storeClient } from '@/service/apiClients'

export default {
  async syncStoreTempState ({ rootGetters, commit }) {
    try {
      const tempState = await storeClient
        .get(`/stores/${rootGetters.storeId}/itemTempState/`)
      const { itemState } = tempState.data
      commit(types.SET_ITEM_GATHER, itemState)
    } catch (e) {
      console.error(e)
    }
  }
}
